import type { AnyAction } from 'redux';
import type { ThunkDispatch, ThunkAction } from 'redux-thunk';

import type { RootState } from 'vms/app/rootReducer';

export function bindThunk<R>(
  actionCreator: (...args: any[]) => ThunkAction<R, RootState, undefined, AnyAction>,
  dispatch: ThunkDispatch<RootState, undefined, AnyAction>
) {
  return (...args: any[]) => dispatch(actionCreator(...args));
}

export function notEmpty<T>(value: T | null | undefined): value is T {
  return value !== null && value !== undefined;
}
